import styled from '@emotion/styled';
import { Link } from 'react-router';
import Paper, { PaperProps } from '@mui/material/Paper';
import {
  HEADER_HEIGHT,
  HAMBURGER_BUTTON_SIZE,
  HEADER_GAP,
  SIDE_BAR_WIDTH,
} from '@/layouts/MainLayout/utils/constants';
import { Theme } from '@mui/material/styles';

export const StyledHeaderContainer = styled.div<{
  isDesktop: boolean;
  theme?: Theme;
}>`
  display: flex;
  align-items: center;
  gap: ${HEADER_GAP};
  width: ${({ isDesktop }) => (isDesktop ? `calc(100% - ${SIDE_BAR_WIDTH})` : '100%')};
  height: ${HEADER_HEIGHT};
  position: fixed;
  top: 0;
  left: ${({ isDesktop }) => (isDesktop ? `${SIDE_BAR_WIDTH}` : 0)};
  z-index: 10;
  padding-left: ${({ isDesktop }) => (isDesktop ? 0 : `${HEADER_GAP}`)};
  border-bottom: 1px solid ${({ theme }) => theme.palette.customSecondary.neutral[500]};
  background-color: ${({ theme }) => theme.palette.customSecondary.background.base};
`;

export const StyledMenuButton = styled.button<{ theme?: Theme }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: none;
  border-radius: 50%;
  width: ${HAMBURGER_BUTTON_SIZE};
  height: ${HAMBURGER_BUTTON_SIZE};
  background-color: ${({ theme }) => theme.palette.customSecondary.neutral[500]};
  color: ${({ theme }) => theme.palette.customSecondary.neutral[200]};
  cursor: pointer;
  transition:
    color 0.3s,
    background-color 0.3s;

  :hover {
    color: ${({ theme }) => theme.palette.customSecondary.neutral[100]};
    background-color: ${({ theme }) => theme.palette.customSecondary.neutral[300]}33;
  }
`;

interface StyledDesktopDrawerPaperProps extends PaperProps {
  theme?: Theme;
}

export const StyledDesktopDrawerPaper = styled(Paper)<StyledDesktopDrawerPaperProps>`
  &.MuiDrawer-paper {
    width: ${SIDE_BAR_WIDTH};
    height: 100%;
    overflow: visible;
  }

  &.MuiDrawer-paper {
    border-right: 1px solid ${({ theme }) => theme.palette.customSecondary.neutral[500]};
    background-color: ${({ theme }) => theme.palette.customSecondary.background.base};
  }
`;

export const StyledMobileDrawerPaper = styled(StyledDesktopDrawerPaper)`
  &.MuiDrawer-paper {
    position: relative;
  }
`;

export const StyledLogoLink = styled(Link)<{ theme?: Theme }>`
  padding-block: 18px;
  height: ${HEADER_HEIGHT};
  color: ${({ theme }) => theme.palette.customSecondary.primary.foreground};
  transition: color 0.3s;

  :hover {
    color: ${({ theme }) => theme.palette.customSecondary.primary.subtle};
  }
`;
